/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable sonarjs/no-duplicate-string */
import { Component, Inject, OnInit, Output } from '@angular/core'
import { BrandService } from '../services/ui/brandService.service'
import { BrandEditorService } from '../services/ui/brand-editor.service'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { BrandFileKeys, FileDto, UniqueFileKeys } from '../services/api/models/file.model'
import { CacheService } from '../services/business/cache.service'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { BrandSettingKeys, DocumentLinkStatus, FeatureSettingKeys, SettingsDocument, sectionOf } from '../services/api/models/configuration.model'
import { PreviewTokenType } from '../../security/models/token.model'
import { jwtDecode } from 'jwt-decode'
import { AuthWrapperService } from '../../security/services/auth'
import { AlertController } from '@ionic/angular/standalone'
import { TranslateService } from '@ngx-translate/core'
import { NotificationService } from '../services/ui/notification.service'
import { removeCircleOutline } from 'ionicons/icons'
import { EventEmitter } from '@angular/core'
import { DOCUMENT } from '@angular/common'
import { distinctUntilChanged } from 'rxjs/operators'

const IMAGE_ACCEPT = '.png, .jpg, .jpeg, .webp, .svg'

@Component({
    selector: 'app-style-configurator',
    templateUrl: './style-configurator.component.html',
    styleUrls: ['./style-configurator.component.scss'],
})
export class StyleConfiguratorComponent implements OnInit {

    faFileUpload = faCheckCircle

    /** Kept only so the form and the file previews can render; colours live in the inspector. */
    brandLoaded = false
    brandFiles: FileDto[]

    /** The draft being edited. The editor service owns it, so there is one writer. */
    get settings(): SettingsDocument {
        return this.editor.document
    }

    /** Which groups are expanded. One record beats a boolean per section. */
    private readonly expanded = new Set<string>()

    isOpen(section: string): boolean {
        return this.expanded.has(section)
    }

    toggleSection(section: string): void {
        if (!this.expanded.delete(section)) this.expanded.add(section)
    }

    /** One entry per image slot, so the panel is a list instead of seven copies of a block. */
    readonly imageSlots = [
        { key: 'Favicon', label: 'favicon', accept: '.png, .svg', hint: '70x70px' },
        { key: 'Logo', label: 'logo', accept: IMAGE_ACCEPT, hint: '220x61px' },
        { key: 'LogoWhite', label: 'logoWhite', accept: IMAGE_ACCEPT, hint: '110x70px' },
        { key: 'CardArt', label: 'card', accept: IMAGE_ACCEPT, hint: '433x285px' },
        { key: 'HomeBackground', label: 'homeBackground', accept: IMAGE_ACCEPT, hint: '1865x1243px' },
        { key: 'LoginWatermark', label: 'loginWatermark', accept: IMAGE_ACCEPT, hint: '638x638px' },
    ]

    /**
     * Documents are just URLs, so they share one compact text field each. The label is named
     * separately because the control names do not all match the translation keys.
     */
    readonly documentFields = [
        { control: 'programFAQ', label: 'programFAQ' },
        { control: 'programDepositAgreement', label: 'programDepositAgreement' },
        { control: 'programPrivacyPolicy', label: 'programPrivacyPolicy' },
        { control: 'portalFAQ', label: 'portalFAQ' },
        { control: 'websiteTermsOfUse', label: 'websiteTermsOfUse' },
        { control: 'cRBPrivacyPolicy', label: 'crbPrivacyPolicy' },
        { control: 'marketingPartnerPrivacyPolicy', label: 'marketingPartnerPrivacyPolicy' },
        { control: 'intraFiCashServiceDepositPlacementAgreement', label: 'intraFiCashServiceDepositPlacementAgreement' },
        { control: 'insuredCashSweepCustodialAgreement', label: 'insuredCashSweepCustodialAgreement' },
    ]

    /**
     * What each document link answered, keyed by control name. A link that is merely well formed
     * still 404s, which is the failure this is here to surface.
     */
    private readonly linkStatus: Record<string, DocumentLinkStatus | 'checking'> = {}

    linkState(control: string): 'checking' | 'ok' | 'broken' | null {
        const status = this.linkStatus[control]

        if (!status) return null
        if (status === 'checking') return 'checking'

        return status.reachable ? 'ok' : 'broken'
    }

    /** The status code when there is one, otherwise the reason, for the tooltip. */
    linkDetail(control: string): string {
        const status = this.linkStatus[control]

        if (!status || status === 'checking') return ''

        return status.statusCode
            ? `${status.statusCode}`
            : this.translateService.instant(`commons.themeConfiguration.documentLink.${status.reason}`) as string
    }

    /** Banner uploads reuse the slot plumbing, they just are not a single image. */
    readonly marketingSlot = { key: 'MarketingBanner' }

    camelKey(slot: { key: string }): string {
        return this.camelize(slot.key)
    }

    previewOf(slot: { key: string }): string {
        return this[`${this.camelize(slot.key)}FilePreviewBase64`] as string
    }

    pathOf(slot: { key: string }): string {
        return this[`${this.camelize(slot.key)}FilePath`] as string
    }

    /** Native file input, so the row can look like the rest of the panel. */
    onFilePicked(slot: { key: string }, event: Event, multiple = false): void {
        const input = event.target as HTMLInputElement
        if (!input.files?.length) return

        const control = this[`${this.camelize(slot.key)}FileInput`] as UntypedFormControl
        control.setValue(multiple ? Array.from(input.files) : input.files[0])

        // Lets the same file be chosen again after a failed upload.
        input.value = ''
    }

    logoFilePath: string
    logoFile: any
    logoFileInput: UntypedFormControl
    logoFilePreviewBase64: any = ''

    faviconFilePath: string
    faviconFile: any
    faviconFileInput: UntypedFormControl
    faviconFilePreviewBase64: any = ''

    cardArtFilePath: string
    cardArtFile: any
    cardArtFileInput: UntypedFormControl
    cardArtFilePreviewBase64: any = ''

    logoWhiteFilePath: string
    logoWhiteFile: any
    logoWhiteFileInput: UntypedFormControl
    logoWhiteFilePreviewBase64: any = ''

    homeBackgroundFilePath: string
    homeBackgroundFile: any
    homeBackgroundFileInput: UntypedFormControl
    homeBackgroundFilePreviewBase64: any = ''

    loginWatermarkFilePath: string
    loginWatermarkFile: any
    loginWatermarkFileInput: UntypedFormControl
    loginWatermarkFilePreviewBase64: any = ''

    marketingBannerFile: any
    marketingBannerFileInput: UntypedFormControl
    marketingBannerImages: FileDto[]

    @Output() public previewModeLoadedEvent = new EventEmitter<void>()

    /** Shown in the header, so it is always clear which brand is being edited. */
    programCode: string
    private crbConfigId: number
    domain: string
    private type: PreviewTokenType = PreviewTokenType.View

    componentLoaded = false

    constructor(
        private brandService: BrandService,
        private editor: BrandEditorService,
        private cacheService: CacheService,
        private authWrapper: AuthWrapperService,
        private alertController: AlertController,
        private translateService: TranslateService,
        private notificationService: NotificationService,
        @Inject(DOCUMENT) private _document: Document,
    ) {
        this.logoFileInput = new UntypedFormControl(this.logoFile)
        this.faviconFileInput = new UntypedFormControl(this.faviconFile)
        this.cardArtFileInput = new UntypedFormControl(this.cardArtFile)
        this.logoWhiteFileInput = new UntypedFormControl(this.logoWhiteFile)
        this.homeBackgroundFileInput = new UntypedFormControl(this.homeBackgroundFile)
        this.loginWatermarkFileInput = new UntypedFormControl(this.loginWatermarkFile)
        this.marketingBannerFileInput = new UntypedFormControl(this.marketingBannerFile)
    }

    public colorForm: UntypedFormGroup = new UntypedFormGroup(
        {
            bankSupportPhoneNumberInput: new UntypedFormControl('', { validators: [Validators.required], updateOn: 'blur' }),
            footerCopyInput: new UntypedFormControl('', { validators: [Validators.required], updateOn: 'blur' }),
            programNameInput: new UntypedFormControl('', { updateOn: 'blur' }),
            intraFiDescriptionInput: new UntypedFormControl('', { validators: [], updateOn: 'blur' }),
            intraFiOptOutBalanceMessageInput: new UntypedFormControl('', { validators: [], updateOn: 'blur' }),
            intraFiOptOutSweptBalanceMessageInput: new UntypedFormControl('', { validators: [], updateOn: 'blur' }),
            isOperatorSiteLinkEnabledInput: new UntypedFormControl(''),
            operatorSiteLinkVerbiageInput: new UntypedFormControl('', { updateOn: 'blur' }),
            operatorSiteLinkUrlInput: new UntypedFormControl('', { updateOn: 'blur' }),
            operatorSiteLinkTextInput: new UntypedFormControl('', { updateOn: 'blur' }),
            isTransferToBankEnabledInput: new UntypedFormControl(''),
            externalBankTransferInfoHeaderInput: new UntypedFormControl('', { updateOn: 'blur' }),
            externalBankTransferInfoBodyInput: new UntypedFormControl('', { updateOn: 'blur' }),
            homeAvailableBalanceWriteOffTitleInput: new UntypedFormControl('', { updateOn: 'blur' }),
            homeAvailableBalanceWriteOffTextInput: new UntypedFormControl('', { updateOn: 'blur' }),
            homeAvailableBalanceWriteOffButtonTextInput: new UntypedFormControl('', { updateOn: 'blur' }),
            homeAvailableBalanceWriteOffHelpTextInput: new UntypedFormControl('', { updateOn: 'blur' }),
            activityDetailsWriteOffWarningTextInput: new UntypedFormControl('', { updateOn: 'blur' }),
            emulateCustomerHasWriteOffInput: new UntypedFormControl(''),
            contactUsTitleTextInput: new UntypedFormControl('', { updateOn: 'blur' }),
            contactUsTextInput: new UntypedFormControl('', { updateOn: 'blur' }),

            programFAQInput: new UntypedFormControl('', { updateOn: 'blur' }),
            programDepositAgreementInput: new UntypedFormControl('', { updateOn: 'blur' }),
            programPrivacyPolicyInput: new UntypedFormControl('', { updateOn: 'blur' }),
            intraFiCashServiceDepositPlacementAgreementInput: new UntypedFormControl('', { updateOn: 'blur' }),
            insuredCashSweepCustodialAgreementInput: new UntypedFormControl('', { updateOn: 'blur' }),
            portalFAQInput: new UntypedFormControl('', { updateOn: 'blur' }),
            websiteTermsOfUseInput: new UntypedFormControl('', { updateOn: 'blur' }),
            cRBPrivacyPolicyInput: new UntypedFormControl('', { updateOn: 'blur' }),
            marketingPartnerPrivacyPolicyInput: new UntypedFormControl('', { updateOn: 'blur' }),
        },
        { updateOn: 'change' }
    )

    async ngOnInit(): Promise<void> {
        this.authWrapper.setAccessToken({
            accessToken: {
                accessToken: this.cacheService.getPreviewToken(),
                tokenType: 'Bearer'
            }
        })

        const token = jwtDecode(this.cacheService.getPreviewToken()) as any

        this.crbConfigId = token.CRBConfigRId
        this.programCode = token.ProgramCode
        this.domain = token.Domain
        this.type = token.Type
        this.cacheService.setPreviewModeType(this.type)
        await this.editor.load(this.domain)
        this.brandLoaded = true

        this.brandFiles = await this.brandService.getBrandFiles(this.domain, true)

        if (this.brandFiles) {
            for (let i = 0; i < UniqueFileKeys.length; i++) {
                const brandFile = UniqueFileKeys[i]
                const apiFile = this.brandFiles.find(q => q.key == brandFile)

                if (apiFile) {
                    this.loadURLToInputFiled(apiFile.url, `${this.camelize(apiFile.key)}FilePreviewBase64`)
                }
            }

            this.brandFiles.forEach(f => {
                this[`${this.camelize(f.key)}FilePath`] = f.path
            })

            this.marketingBannerImages = this.brandFiles.filter(f => f.key === BrandFileKeys.MarketingBanner)
        }

        this.loadSettingsIntoForm()
        this.documentFields.forEach(field => void this.checkDocumentLink(field.control))

        this.initializeEvents()

        this.brandService.applyTheme(this.editor.theme.value)
        await this.brandService.setFiles(this.brandFiles)
        CacheService.brandConfigurationSettingsChanged.next(true)

        this.componentLoaded = true
        this.previewModeLoadedEvent.emit()
    }

    public async removeFile(fileKey: string): Promise<void> {

        const alert = await this.alertController.create({
            mode: 'md',
            cssClass: 'confirmation-prompt',
            header: this.translateService.instant('commons.themeConfiguration.messages.removeFileHeader') as string,
            subHeader: this.translateService.instant('commons.themeConfiguration.messages.areYouSureRemoveFile') as string,
            buttons: [
                {
                    text: this.translateService.instant(
                        'commons.themeConfiguration.messages.cancel'
                    ) as string,
                },
                {
                    text: this.translateService.instant(
                        'commons.themeConfiguration.messages.remove'
                    ) as string,
                    handler: async () => {
                        await this.editor.save(document => delete document.images[fileKey])

                        this[`${this.camelize(fileKey)}FilePath`] = null
                        this[`${this.camelize(fileKey)}FilePreviewBase64`] = ''

                        await this.reloadConfiguration()
                    }
                },
            ],
        })
        await alert.present()
    }

    public async removeMarketingFile(path: string): Promise<void> {

        const alert = await this.alertController.create({
            mode: 'md',
            cssClass: 'confirmation-prompt',
            header: this.translateService.instant('commons.themeConfiguration.messages.removeFileHeader') as string,
            subHeader: this.translateService.instant('commons.themeConfiguration.messages.areYouSureRemoveFile') as string,
            buttons: [
                {
                    text: this.translateService.instant(
                        'commons.themeConfiguration.messages.cancel'
                    ) as string,
                },
                {
                    text: this.translateService.instant(
                        'commons.themeConfiguration.messages.remove'
                    ) as string,
                    handler: async () => {
                        await this.editor.save(document => {
                            document.images[BrandFileKeys.MarketingBanner] =
                                (document.images[BrandFileKeys.MarketingBanner] ?? []).filter(p => p !== path)
                        })

                        this.marketingBannerImages = this.marketingBannerImages.filter(f => f.path !== path)

                        await this.reloadConfiguration()
                    }
                },
            ],
        })
        await alert.present()
    }

    private async reloadConfiguration() {
        await this.editor.load(this.domain)
        this.brandFiles = await this.brandService.getBrandFiles(this.domain, true)

        this.brandService.applyTheme(this.editor.theme.value)
        await this.brandService.setFiles(this.brandFiles)
        this.cacheService.setBrandConfigSettings(this.settings)

        this.cacheService.setConfiguredBrandingColors(this.editor.theme.value?.light.elements)
        this.cacheService.setConfiguredBrandingFiles(this.brandFiles)
        this.cacheService.setConfiguredBrandConfigSettings(this.settings)

        CacheService.brandConfigurationSettingsChanged.next(true)
    }

    private loadURLToInputFiled(url: string, fileInput: string): void {
        if (url) {
            this[fileInput] = url
        }
    }

    private initializeEvents() {

        // Wired from the slot list, so a slot cannot be shown without being hooked up. Card art
        // was listed but never subscribed, which left it the one image that would not upload.
        this.imageSlots.forEach(slot => {
            const control = this[`${this.camelize(slot.key)}FileInput`] as UntypedFormControl

            control.valueChanges.subscribe(() => this.setFilePreview(slot.key))
        })

        this.marketingBannerFileInput.valueChanges.subscribe(() => {
            try {
                const files = this['marketingBannerFileInput'].value

                files.forEach(f => {
                    const reader = new FileReader()
                    reader.readAsDataURL(f)
                    reader.onload = async () => {
                        const base64FileContent = reader.result as string
                        const uploaded = await this.brandService.uploadBrandFile({
                            content: base64FileContent.split(',').pop(),
                            fileKey: BrandFileKeys.MarketingBanner,
                            filename: f.name
                        })

                        await this.editor.save(document => {
                            const banners = document.images[BrandFileKeys.MarketingBanner] ?? []
                            document.images[BrandFileKeys.MarketingBanner] = [...banners, uploaded.path]
                        })

                        this.marketingBannerImages.push({ ...uploaded, url: base64FileContent })
                    }
                })
            }
            catch (err) {
                void this.notificationService.showToasterErrorMessage((this.translateService.instant('commons.themeConfiguration.files.error') as string) + err?.error?.error as string)
                void this.reloadConfiguration()
            }
        })

        this.colorForm.controls['isOperatorSiteLinkEnabledInput'].valueChanges.subscribe((value) => {
            if (value) {
                this.colorForm.controls['operatorSiteLinkVerbiageInput'].enable({
                    emitEvent: false,
                })
                this.colorForm.controls['operatorSiteLinkUrlInput'].enable({
                    emitEvent: false,
                })
                this.colorForm.controls['operatorSiteLinkTextInput'].enable({
                    emitEvent: false,
                })
            }
            else {

                this.colorForm.controls['operatorSiteLinkVerbiageInput'].disable({
                    emitEvent: false,
                })
                this.colorForm.controls['operatorSiteLinkUrlInput'].disable({
                    emitEvent: false,
                })
                this.colorForm.controls['operatorSiteLinkTextInput'].disable({
                    emitEvent: false,
                })
            }

            void this.updateSettings()
        })

        this.colorForm.controls['isTransferToBankEnabledInput'].valueChanges.subscribe((value) => {
            if (value) {
                this.colorForm.controls['externalBankTransferInfoHeaderInput'].enable({
                    emitEvent: false,
                })
                this.colorForm.controls['externalBankTransferInfoBodyInput'].enable({
                    emitEvent: false,
                })
            }
            else {
                this.colorForm.controls['externalBankTransferInfoHeaderInput'].disable({
                    emitEvent: false,
                })
                this.colorForm.controls['externalBankTransferInfoBodyInput'].disable({
                    emitEvent: false,
                })
            }

            void this.updateSettings()
        })

        this.colorForm.controls['bankSupportPhoneNumberInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['programNameInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['footerCopyInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['intraFiDescriptionInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['intraFiOptOutBalanceMessageInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['intraFiOptOutSweptBalanceMessageInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['operatorSiteLinkVerbiageInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['operatorSiteLinkUrlInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['operatorSiteLinkTextInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['externalBankTransferInfoHeaderInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['externalBankTransferInfoBodyInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['homeAvailableBalanceWriteOffTitleInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['emulateCustomerHasWriteOffInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['homeAvailableBalanceWriteOffTextInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['homeAvailableBalanceWriteOffButtonTextInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['homeAvailableBalanceWriteOffHelpTextInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['activityDetailsWriteOffWarningTextInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['contactUsTitleTextInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        this.colorForm.controls['contactUsTextInput'].valueChanges.subscribe(() => {
            void this.updateSettings()
        })

        // Documents are the same field nine times over, so they are wired in one place.
        this.documentFields.forEach(field => {
            const control = this.colorForm.controls[`${field.control}Input`]

            control.valueChanges.subscribe(() => void this.updateSettings())

            // These controls commit on blur, so the value arrives once typing is over already.
            // Only a link that actually changed is worth asking about again.
            control.valueChanges
                .pipe(distinctUntilChanged())
                .subscribe(() => void this.checkDocumentLink(field.control))
        })
    }

    private async updateFile(fileKey: string) {
        try {
            const uploaded = await this.brandService.uploadBrandFile({
                fileKey: BrandFileKeys[fileKey] as string,
                filename: this[`${this.camelize(fileKey)}FileInput`]?.value?.name,
                content: this[`${this.camelize(fileKey)}FilePreviewBase64`].split(',').pop()
            })

            // The draft points at the new blob while what is live keeps pointing at the old one.
            await this.editor.save(document => {
                document.images[BrandFileKeys[fileKey] as string] = [uploaded.path]
            })

            this[`${this.camelize(fileKey)}FilePath`] = uploaded.path
            await this.reloadConfiguration()
        }
        catch (err) {
            await this.notificationService.showToasterErrorMessage((this.translateService.instant('commons.themeConfiguration.files.error') as string) + err?.error?.error as string)
            this[`${this.camelize(fileKey)}FilePreviewBase64`] = ''
            await this.reloadConfiguration()
        }
    }

    private setFilePreview(fileKey: string) {
        const reader = new FileReader()
        reader.readAsDataURL(this[`${this.camelize(fileKey)}FileInput`].value)
        reader.onload = () => {
            this[`${this.camelize(fileKey)}FilePreviewBase64`] = reader.result
            void this.updateFile(fileKey)
        }
    }


    private async checkDocumentLink(control: string): Promise<void> {
        const url = (this.colorForm.get(`${control}Input`)?.value as string)?.trim()

        if (!url) {
            delete this.linkStatus[control]
            return
        }

        this.linkStatus[control] = 'checking'

        try {
            this.linkStatus[control] = await this.brandService.checkDocumentLink(url)
        }
        catch {
            this.linkStatus[control] = { reachable: false, reason: 'checkFailed' }
        }
    }

    /** Each key goes to the section that holds it, so a flag is stored as a flag. */
    private loadSettingsIntoForm(): void {
        const settings = this.settings

        BrandSettingKeys.forEach(key => {
            const control = this.colorForm.get(`${key}Input`)
            if (!control) return

            if (sectionOf(key) === 'features')
                control.setValue(settings.features[key] === true)
            else
                control.setValue(settings[sectionOf(key)][key] ?? '')
        })
    }

    private async updateSettings() {
        // Trigger validation update
        this.colorForm.updateValueAndValidity()

        if (this.colorForm.valid) {
            await this.editor.save(document => {
                BrandSettingKeys.forEach(key => {
                    const value = this.colorForm.get(`${key}Input`)?.value

                    if (FeatureSettingKeys.includes(key))
                        document.features[key] = value === true || value === 'true'
                    else if (value === null || value === undefined || value === '')
                        delete document[sectionOf(key)][key]
                    else
                        document[sectionOf(key)][key] = `${value}`
                })
            })

            await this.reloadConfiguration()
        }
        else {
            await this.notificationService.showToasterErrorMessage(this.translateService.instant('commons.themeConfiguration.messages.invalidInput') as string)
        }
    }

    private camelize(str): string {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase()
        }).replace(/\s+/g, '').replace('cRB', 'crb')
    }

    public async publishConfiguration(): Promise<void> {
        const alert = await this.alertController.create({
            mode: 'md',
            cssClass: 'confirmation-prompt',
            header: this.translateService.instant('commons.themeConfiguration.messages.publishConfigurationHeader') as string,
            subHeader: this.translateService.instant('commons.themeConfiguration.messages.areYouSurePublishConfiguration') as string,
            buttons: [
                {
                    text: this.translateService.instant(
                        'commons.themeConfiguration.messages.cancel'
                    ) as string,
                },
                {
                    text: this.translateService.instant(
                        'commons.themeConfiguration.messages.publish'
                    ) as string,
                    handler: async () => {
                        try {
                            const success = await this.brandService.publishBrandConfiguration(this.crbConfigId, this.programCode)
                            if (success) {
                                void this.notificationService.showToasterMessage({
                                    message: this.translateService.instant('commons.themeConfiguration.messages.publishSuccessMessage') as string,
                                })
                            }
                            else {
                                void this.notificationService.showToasterErrorMessage(
                                    this.translateService.instant('commons.themeConfiguration.messages.publishErrorMessage') as string,
                                )
                            }
                        }
                        catch {
                            void this.notificationService.showUnhandledToasterErrorMessage()
                        }
                    }
                },
            ],
        })
        await alert.present()
    }
}
